export default __webpack_public_path__ + "static/media/ri_coupon-4-line.3cfe1188.svg";